import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from './components/ui/sonner';
import Header from './components/Header';
import Hero from './components/Hero';
import SolutionTabs from './components/SolutionTabs';
import Services from './components/Services';
import AirFreight from './components/AirFreight';
import Stats from './components/Stats';
import WhyChoose from './components/WhyChoose';
import Testimonials from './components/Testimonials';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Partners from './pages/Partners';

const LandingPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <Hero />
        <SolutionTabs />
        <Services />
        <AirFreight />
        <Stats />
        <WhyChoose />
        <Testimonials />
        <Contact />
      </main>
      <Footer />
      <Toaster position="bottom-right" richColors />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/partners" element={<Partners />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
